@for (link of links; track trackByLinkId($index, link)) {
    <div  class="doc-assoctiation display--nowrap align--tiny-bottom align--tiny-top">
        @if (link.id) {
            <div class="display--flex">
                <span class="text--nowrap">{{link.label}}:</span>
                <a
                    [tooltip]="link.number"
                    class="text--ellipsis link link--blue align--tiny-left"
                    (click)="onHrefClick($event, link)"
                    [routerLink]="getRoute(link)!.url | sklCompanyLink"
                    [queryParams]="getRoute(link)!.params">
                    {{link.number}}
                </a>
            </div>
        }
    </div>
}